// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-1322cef6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/index.js?{}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./message-preview.vue");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../../node_modules/vue-style-loader/lib/addStylesClient.js")("a789855a", content, false);
// Hot Module Replacement
if(module.hot) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-1322cef6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/index.js?{}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./message-preview.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-1322cef6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/index.js?{}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./message-preview.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-style-loader!./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-1322cef6","scoped":true,"hasInlineConfig":false}!./~/sass-loader?{}!./~/vue-loader/lib/selector.js?type=styles&index=0!./scripts/src/pages/referral-program/message-preview.vue
// module id = 885
// module chunks = 0